import { render, staticRenderFns } from "./certificate.vue?vue&type=template&id=91e6848a&scoped=true"
import script from "./certificate.vue?vue&type=script&lang=js"
export * from "./certificate.vue?vue&type=script&lang=js"
import style0 from "./certificate.vue?vue&type=style&index=0&id=91e6848a&prod&lang=less&scoped=true"
import style1 from "./certificate.vue?vue&type=style&index=1&id=91e6848a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e6848a",
  null
  
)

export default component.exports